// extracted by mini-css-extract-plugin
export default {"searchInfoWrapper":"searchInfoSP_searchInfoWrapper__-R7qK","destination":"searchInfoSP_destination__5dRa-"};